import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/home.vue'
import Index from '../components/index.vue'
import Feature from '../components/feature.vue'
import Release from '../components/release.vue'
import Voc from '../components/voiceofcustomer.vue'
import Download from '../components/download.vue'
import Link from '../components/link.vue'
import Contact from '../components/contact.vue'
import Register from '../components/register.vue'
import Query from '../components/query.vue'
import globalConst from '../components/globalConst.vue'
import MojiScanLanding from '../components/mojiscan/landing.vue'
import BookMarkSearchLanding from '../components/bookmarksearch/landing.vue'
import i18n from '../i18n'
import {
  MOJISCAN_VERSION,
  MOJISCAN_ZIP_NAME
} from '../components/mojiscan/mojiscanConst'
import {
  BOOKMARKSEARCH_VERSION,
  BOOKMARKSEARCH_ZIP_NAME
} from '../components/bookmarksearch/bookmarksearchConst'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/link.html',
      redirect: '/link'
    },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', redirect: 'index' },
        {
          path: 'index',
          component: Index,
          meta: {
            titleKey: 'meta.index.title',
            descriptionKey: 'meta.index.description'
          }
        },
        {
          path: 'feature',
          component: Feature,
          meta: {
            titleKey: 'meta.feature.title',
            descriptionKey: 'meta.feature.description'
          }
        },
        {
          path: 'release',
          component: Release,
          meta: {
            titleKey: 'meta.release.title',
            descriptionKey: 'meta.release.description'
          }
        },
        {
          path: 'voiceofcustomer',
          component: Voc,
          meta: {
            titleKey: 'meta.voc.title',
            descriptionKey: 'meta.voc.description'
          }
        },
        {
          path: 'download',
          component: Download,
          meta: {
            titleKey: 'meta.download.title',
            descriptionKey: 'meta.download.description'
          }
        },
        {
          path: 'link',
          component: Link,
          meta: {
            titleKey: 'meta.link.title',
            descriptionKey: 'meta.link.description'
          }
        },
        {
          path: 'contact',
          component: Contact,
          meta: {
            titleKey: 'meta.contact.title',
            descriptionKey: 'meta.contact.description'
          }
        },
        {
          path: 'register',
          component: Register,
          meta: {
            titleKey: 'meta.register.title',
            descriptionKey: 'meta.register.description'
          }
        },
        {
          path: 'query',
          component: Query,
          meta: {
            titleKey: 'meta.query.title',
            descriptionKey: 'meta.query.description'
          }
        }
      ]
    },
    {
      path: '/mojiscan',
      component: MojiScanLanding,
      meta: {
        titleKey: 'meta.mojiscan.title',
        descriptionKey: 'meta.mojiscan.description'
      }
    },
    {
      path: '/bookmarksearch',
      component: BookMarkSearchLanding,
      meta: {
        titleKey: 'meta.bookmarksearch.title',
        descriptionKey: 'meta.bookmarksearch.description'
      }
    }
  ]
})

const PRODUCT_PARAMS = {
  '/mojiscan': () => ({
    version: MOJISCAN_VERSION,
    zipName: MOJISCAN_ZIP_NAME,
    price: i18n.t('mojiscan.price')
  }),
  '/bookmarksearch': () => ({
    version: BOOKMARKSEARCH_VERSION,
    zipName: BOOKMARKSEARCH_ZIP_NAME,
    price: i18n.t('bookmarksearch.price')
  })
}

// Navigation Guard for SEO
export function updateDocumentMeta (to) {
  const baseUrl = 'https://www.searchplusplus.jp'

  const title = (to.meta && to.meta.titleKey) ? i18n.t(to.meta.titleKey) : i18n.t('meta.defaultTitle')
  const params = PRODUCT_PARAMS[to.path] ? PRODUCT_PARAMS[to.path]() : {}
  const description = (to.meta && to.meta.descriptionKey)
    ? i18n.t(to.meta.descriptionKey, params)
    : i18n.t('meta.defaultDescription')
  const url = `${baseUrl}${to.fullPath}`

  // Update Title
  document.title = title

  // Helper to update meta tags
  const updateMetaTag = (name, content, property = false) => {
    const attribute = property ? 'property' : 'name'
    let element = document.querySelector(`meta[${attribute}="${name}"]`)
    if (element) {
      element.setAttribute('content', content)
    } else {
      element = document.createElement('meta')
      element.setAttribute(attribute, name)
      element.setAttribute('content', content)
      document.getElementsByTagName('head')[0].appendChild(element)
    }
  }

  // Update standard meta tags
  updateMetaTag('description', description)
  updateMetaTag('title', title)

  // Update Open Graph tags
  updateMetaTag('og:title', title, true)
  updateMetaTag('og:description', description, true)
  updateMetaTag('og:url', url, true)

  // Social card image (MojiScan has its own 1200x630 card)
  const image = `${baseUrl}/${to.path === '/mojiscan' ? 'MojiScan_og.png' : 'og-image.png'}`
  updateMetaTag('og:image', image, true)
  updateMetaTag('og:image:width', '1200', true)
  updateMetaTag('og:image:height', '630', true)

  // Update Twitter tags
  updateMetaTag('twitter:title', title)
  updateMetaTag('twitter:description', description)
  updateMetaTag('twitter:url', url)
  updateMetaTag('twitter:image', image)

  // Update Canonical link
  let link = document.querySelector('link[rel="canonical"]')
  if (link) {
    link.setAttribute('href', url)
  } else {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    link.setAttribute('href', url)
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}

router.afterEach((to) => {
  updateDocumentMeta(to)
})

Vue.prototype.$globalConst = globalConst
export default router
